import { TaskService } from './task.service';

export default angular
  .module('sfMobile.services.task', [
    'sfMobile.constants.task-statuses',
    'sfMobile.constants.task-assignees',
  ])
  .service('taskService', TaskService).name;
